import { Component, Mixins, Emit } from 'vue-property-decorator';
import {
    formatDate,
    formatTime,
    MagicConfigMixin,
    toUtc,
} from '@gig/magic-common';
import { magic } from '@gig/magic-sdk';
import { RESPONSIBLE_GAMING_NAMESPACE } from '../../store/modules/responsible-gaming';
import { store } from '../../store';

@Component({
    name: 'responsible-gaming-modal',
})
export default class ResponsibleGamingModalComponent extends Mixins(
    MagicConfigMixin,
) {
    rgState = store.state[RESPONSIBLE_GAMING_NAMESPACE];

    @Emit('close')
    close() {
        return;
    }

    logout() {
        magic.methods.users.logout();
        this.close();
    }

    get date(): string {
        const date = toUtc(this.rgState?.blocks.endDate!);
        return formatDate(date) + ' @ ' + formatTime(date);
    }
}
